import styled from 'styled-components';
import { Layout, Avatar, Row } from 'antd';
import { TextRegular14 } from 'styles/typography';
import { cssMediaBreakpoints } from 'utils/responsiveQuery/breakpoints';

export const HeaderLayout = styled(Row)`
  ${cssMediaBreakpoints.mobileOrTablet} {
    overflow-x: auto;
  }
  .header-sidebar-toggle-button {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .var-select-icon {
    font-size: 16px;
    margin-left: 12px;
    vertical-align: middle;
  }
`;

export const AvatarImg = styled(Avatar)`
  margin-right: 8px;
`;

export const Header = styled(Layout.Header)`
  background: ${p => p.theme.backgroundColor};
  border: 1px solid ${p => p.theme.borderColor};
  border-left: unset;
  height: 69px;
  padding: 0 24px;
`;

export const SelectTitle = styled(TextRegular14)`
  margin-left: 5px;
`;
